'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toSimpleSession = toSimpleSession;
exports.toSimpleDepartures = toSimpleDepartures;
exports.toSimpleDeparture = toSimpleDeparture;
exports.toSimpleProductLines = toSimpleProductLines;
exports.toSimpleProductLine = toSimpleProductLine;
exports.toSimplePassengers = toSimplePassengers;
exports.hasClearlyInvalidPassengerAssignments = hasClearlyInvalidPassengerAssignments;
exports.toTravelPackageProducts = toTravelPackageProducts;
exports.toSimpleExtraQuestions = toSimpleExtraQuestions;
function toSimpleSession(old) {
    var simple = {
        Customer: old.Customer,
        InvoiceCustomer: old.InvoiceCustomer,
        Num: {
            Adult: old.NumAdults,
            Child: old.NumChildren,
            Infant: old.NumInfants
        },
        Departures: toSimpleDepartures(old.Departures),
        ProductLines: toSimpleProductLines(old.Products),
        Passengers: toSimplePassengers(old.Passengers),
        PriceGroup: old.PriceGroup,
        ClerkID: old.ClerkID,
        OfficeID: old.OfficeID,
        MessageToBooking: old.MessageToBooking,
        DiscountCode: old.DiscountCode,
        GiftCards: old.GiftCards
    };
    // console.log('[Utils] Session:', simple);
    return simple;
}

function toSimpleDepartures(oldDepartures) {
    if (!oldDepartures) return oldDepartures;
    return _.map(oldDepartures, toSimpleDeparture);
}

function toSimpleDeparture(old) {
    return {
        DestinationCode: old.DestinationCode,
        BeginDate: old.DepartureDate,
        EndDate: old.ArrivalDate2
    };
}

function toSimpleProductLines(oldLines) {
    if (!oldLines) return oldLines;
    oldLines = _.filter(oldLines, function (oldLine) {
        return oldLine.Amount > 0;
    });
    oldLines = _.map(oldLines, toSimpleProductLine);
    return oldLines;
}

function toSimpleProductLine(old) {
    return {
        Amount: old.Amount,
        DestinationCode: old.Product.DestinationInfo.DestinationCode,
        ProductCode: old.Product.DestinationInfo.ProductCode,
        BeginDate: old.Product.BeginDate,
        EndDate: old.Product.EndDate,
        PassengerAssignments: old.PassengerAssignments,
        PriceSelections: old.PriceSelections,
        PriceGroup: old.PriceGroup,
        BusStopID: old.BusStopID,
        ExtraQuestions: toSimpleExtraQuestions(old.Product.ExtraQuestions),
        Link: old.Link,
        Price: old.TotalPrice,
        Parent: old.Parent,
        BeginTime: old.Product.BeginTime,
        EndTime: old.Product.EndTime
    };
}

function toSimplePassengers(oldLines) {
    var lines = _.cloneDeep(oldLines);
    _.each(lines, function (line) {
        if (!line.Gender) line.Gender = 'MR';
    });
    return lines;
}

function hasClearlyInvalidPassengerAssignments(bookingSession) {
    var lines = bookingSession && bookingSession.Products;
    if (!lines) return false;

    return _.some(lines, function (line) {
        if (!line || !line.PassengerAssignments) return false;

        var prod = line && line.Product;
        if (!prod) return false;

        // Get list of possible assignments, if available
        var possibleAssignments = prod.PossiblePassengerAssignments;

        // Can this be booked without any passengers assigned?
        // Note that if we have no information about possible assignments, we assume
        // that booking is possible.
        var allowEmpty = !possibleAssignments || _.includes(possibleAssignments, 'A0C0I0');

        // If there are no passenger assignments at all, but this is a room, there is a problem.
        if (line.PassengerAssignments.length === 0 && !allowEmpty) {
            return true;
        }

        // Group passenger assignments by room so we can check that each individual
        // room has valid assignments.
        var byRoom = _.groupBy(line.PassengerAssignments, function (pa) {
            return pa.ProductNumber;
        });

        return _.some(byRoom, function (assignments) {
            // The number of passengers assigned to this room
            var count = assignments.length;

            if (count === 0) {
                // No passengers assigned to the room at all
                return !allowEmpty;
            } else if (count === 1) {
                // Just a single passenger (note: this doesn't disregard infants etc.)
                var di = prod.DestinationInfo;
                var isAcc = di && di.Accommodation;
                var noSingles = isAcc && prod.HasSinglePassengerPrice === false;
                return noSingles;
            } else {
                // Assume not invalid
                return false;
            }
        });
    });
}

function toTravelPackageProducts(products) {
    var simple = _.map(_.filter(products, function (productLine) {
        return !productLine.IsDiscountProduct;
    }), // This check may be temporary. (Should discount product exist in backend?)
    function (productLine) {
        return {
            DestinationCode: productLine.Product.DestinationInfo.DestinationCode,
            ProductCode: productLine.Product.DestinationInfo.ProductCode,
            Price: productLine.TotalPrice || 0
        };
    });

    return simple;
}

function toSimpleExtraQuestions(extraQuestions) {
    return _.map(extraQuestions, function (extraQuestion) {
        return {
            Question: extraQuestion.Question,
            Answer: extraQuestion.Answer
        };
    });
}


//////////////////
// WEBPACK FOOTER
// ./src/winresCloud/utils.js
// module id = 557
// module chunks = 2